"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
var React = require("react");
var styles = require("./index.scss");
function Loading() {
    return (React.createElement("div", { className: styles.loadingDotWrapper },
        React.createElement("div", { className: styles.loader },
            React.createElement("div", { className: styles.loaderdot }),
            React.createElement("div", { className: styles.loaderdot }),
            React.createElement("div", { className: styles.loaderdot }),
            React.createElement("div", { className: styles.loaderdot }),
            React.createElement("div", { className: styles.loaderText }))));
}
exports.Loading = Loading;
exports.default = Loading;
